module.exports = __webpack_public_path__ + "assets/ca7ce768af62a2894af12f1909a7c494.png";